import React, { useEffect, useState, useContext } from 'react';
import { getUserDetails } from '../../services/authService';
import { AuthContext } from '../../contexts/AuthContext';
// import navigate component from react-router-dom
import { useNavigate } from 'react-router-dom';

function Profile() {
    const { authTokens } = useContext(AuthContext);
    const navigate = useNavigate();
    const [user, setUser] = useState({
        first_name: '',
        last_name: '',
        phone_number: '',
        country: '',
        state: '',
        city: '',
        area: '',
        date_of_birth: '',
        bio: '',
    });

    const [loading, setLoading] = useState(true);

    console.log('User Profile:', user);
    useEffect(() => {
        getUserDetails()
            .then((response) => {
                setUser(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-900">
                <p className="text-white text-lg">Loading profile...</p>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex justify-center items-center py-12 px-4">
            <div className="bg-gray-900 max-w-3xl w-full p-8 rounded-lg shadow-xl text-white border border-gray-800">
                <h2 className="mb-8 text-4xl font-bold text-yellow-500 text-center">Your Profile</h2>
                
                {/* Profile Details */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* First Name */}
                    <div>
                        <p className="text-gray-400 font-medium">First Name</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.first_name || 'N/A'}</p>
                    </div>
                    {/* Last Name */}
                    <div>
                        <p className="text-gray-400 font-medium">Last Name</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.last_name || 'N/A'}</p>
                    </div>
                    {/* Phone Number */}
                    <div>
                        <p className="text-gray-400 font-medium">Phone Number</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.phone_number || 'N/A'}</p>
                    </div>
                    {/* Date of Birth */}
                    <div>
                        <p className="text-gray-400 font-medium">Date of Birth</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.date_of_birth || 'N/A'}</p>
                    </div>
                    {/* Country */}
                    <div>
                        <p className="text-gray-400 font-medium">Country</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.country || 'N/A'}</p>
                    </div>
                    {/* State */}
                    <div>
                        <p className="text-gray-400 font-medium">State</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.state || 'N/A'}</p>
                    </div>
                    {/* City */}
                    <div>
                        <p className="text-gray-400 font-medium">City</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.city || 'N/A'}</p>
                    </div>
                    {/* Area */}
                    <div>
                        <p className="text-gray-400 font-medium">Area</p>
                        <p className="text-lg font-semibold text-white mt-1">{user.area || 'N/A'}</p>
                    </div>
                </div>

                {/* Bio Section */}
                <div className="mt-8">
                    <p className="text-gray-400 font-medium">Bio</p>
                    <p className="text-lg font-semibold text-white mt-2 leading-relaxed">{user.bio || 'No bio available.'}</p>
                </div>

                {/* Button (Optional Future Action) */}
                <div className="mt-10 flex justify-center">
                    <button
                        type="button"
                        onClick={() => navigate('/edit-profile')}
                        className="px-6 py-3 text-lg font-bold bg-yellow-500 text-gray-900 rounded-md hover:bg-yellow-600 transition duration-300"
                    >
                        Edit Profile
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Profile;
